import React from "react";
import PropTypes from "prop-types";
import { VscChromeMinimize, VscCallIncoming } from "react-icons/vsc";
import { defaultChatBotSettings } from "../../consts/settings";
import {useQuery} from "../../helpers/hooks/common-hook";

function ChatHeader({ settingsState, chatBotSetting, toggleVoiceMode, onClose }) {
  const query = useQuery();
  const test_voice_mode = query.get("test_voice_mode");

  const getTitle = () => {
    if (settingsState.processing) {
      return "";
    }
    if (settingsState.failed || !chatBotSetting.title) {
      return defaultChatBotSettings.title;
    }
    return chatBotSetting.title;
  };

  return (
    <div
      style={{
        backgroundColor: chatBotSetting.headerBackgroundColor,
      }}
      className="flex items-center justify-between w-full h-14 px-5"
    >
      <div className="chat-plugin-text flex items-center gap-4">
        <div>
          <h3 className="text-base font-semibold text-white">{getTitle()}</h3>
        </div>
      </div>
      <div className="chat-plugin-option flex items-center gap-2">
        {/* TODO remove this test_voice_mode based voice enable. should be handle by user's subscription plan  */}
        {test_voice_mode &&
            <button
                onClick={toggleVoiceMode}
                className="w-7 h-7 bg-transparent flex items-center justify-center"
            >
              <VscCallIncoming size={17} className="invert " />
            </button>
        }
        <button className="w-7 h-7 bg-transparent flex items-center justify-center" onClick={onClose}>
          <VscChromeMinimize size={19} className="invert" />
        </button>
      </div>
    </div>
  );
}

ChatHeader.propTypes = {
  settingsState: PropTypes.shape({
    processing: PropTypes.bool.isRequired,
    success: PropTypes.bool.isRequired,
    failed: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string,
  }).isRequired,
  chatBotSetting: PropTypes.shape({
    headerBackgroundColor: PropTypes.string,
    title: PropTypes.string,
    logo: PropTypes.string,
  }).isRequired,
  toggleVoiceMode: PropTypes.func.isRequired,
};

export default ChatHeader;
